
interface IconProps {
  className?: string;
}

export function GoogleIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 48 48"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.21 1.53 7.63 2.81l5.22-5.22C33.32 3.74 29.08 2 24 2 14.82 2 6.88 7.44 3.17 15.3l6.09 4.73C11.12 13.92 17.08 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46 24.5c0-1.66-.15-3.25-.43-4.78H24v9.04h12.4c-.53 2.88-2.16 5.31-4.6 6.94l7.04 5.44C42.79 37.44 46 31.48 46 24.5z"
      />
      <path
        fill="#FBBC05"
        d="M9.26 28.03a13.92 13.92 0 0 1 0-8.06l-6.09-4.73a22 22 0 0 0 0 17.52l6.09-4.73z"
      />
      <path
        fill="#34A853"
        d="M24 46c5.08 0 9.32-1.67 12.43-4.52l-7.04-5.44c-1.95 1.31-4.45 2.08-7.39 2.08-6.92 0-12.88-4.42-14.74-10.53l-6.09 4.73C6.88 40.56 14.82 46 24 46z"
      />
    </svg>
  );
}

